import * as ko from "knockout";

ko.components.register('person-info-modal', {
	viewModel: function (params) {
		var self = this;
		self.person = ko.observable(params.person);
		self.id = params.id;

        console.log('registering');

        self.person.subscribe(function(){
            console.log('person changed!');
        });
	},
	template:
		`
        <div class="modal fade" data-bind="attr: {id: id}" aria-hidden="true" aria-labelledby="personInfoModalLabel" tabindex="-1">
			<!-- ko with: person -->
			<div class="modal-dialog" role="dialog">
				<div class="modal-content">
					<div class="modal-header">
							<span class="modal-title" id="personInfoModalLabel"
                                  data-bind="text:display_name"></span>
							<span class="user-select-all font-monospace" data-bind="text: person_uuid"></span>
					</div>
					<div class="modal-body">
						<div class="container p-0">
							<div class="row">
									<div class="col-3">Person:</div>
									<div class="col">
										<div data-bind="text:display_name"></div>
                                        <div data-bind="text:inserted().format('DD.MM.YYYY')"></div>
										<div class="user-select-all font-monospace" data-bind="text:person_uuid()"></div>
									</div>
							</div>
							<div class="row">
									<div class="col-3">Phone #:</div>
									<div class="col" data-bind="text:phone"></div>
							</div>
							<div class="row">
								<div class="col-3">Email:</div>
								<div class="col">
									<a data-bind="attr: {href : 'mailto:' + email_address()}, text: email_address"></a>
								</div>
							</div>
							<div class="row">
								<div class="col-3">Language:</div>
								<div class="col" data-bind="text:language"></div>
							</div>
							<div class="row">
								<div class="col-3">Comment:</div>
								<div class="col" data-bind="if: ">
									<extra-notes params="data: "></extra-notes>
								</div>
							</div>
							<!-- ko if: billing_details().mangopayid -->
							<div class="row">
								<div class="col-3">Mango Pay ID:</div>
								<div class="col">
                                    <a  target="_blank"
                                        data-bind="attr:{href:'https://hub.mangopay.com/production/eu/sofaconcerts/users/' + billing_details().mangopayid() },
                                        text:billing_details().mangopayid()"></a>
                                </div>
							</div>
							<!-- /ko -->
							<h5 class="mt-2">Invoice Email Log</h5>
                            <div data-bind="foreach:email_sent_log">
                                <div class="row">
								<div class="col-3"
                                     data-bind="text:inserted.format('DD.MM.YYYY')"></div>
								<div class="col"
                                    data-bind="text:email_template_name">
                                </div>
                                </div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">Close</button>
					</div> <!-- closes modal-footer -->
				</div> <!-- closes modal-content -->
			</div> <!-- closes modal-dialog -->
			<!-- /ko -->
		</div>
        `
});
